import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {Subscription} from 'rxjs';
import {disableScroll, enableScroll} from '../../utils/scroll-disable.utils';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {ConfirmService} from '../../../core/services/confirm/confirm.service';

@Component({
  selector: 'app-confirm',
  imports: [
    NgClass,
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './confirm.component.html',
  styleUrl: './confirm.component.css'
})
export class ConfirmComponent implements OnInit, OnDestroy {
  private confirm = inject(ConfirmService)

  dialogVisible = false;
  dialogTitle = 'Подтверждение';
  dialogMessage = 'Вы уверены?';
  type: string = '';
  inputVisible = false;

  private dialogSub!: Subscription;

  constructor(
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.dialogSub = this.confirm.getDialogState().subscribe((state) => {
      this.dialogVisible = state.visible;
      this.dialogTitle = state.title;
      this.dialogMessage = state.message;
      this.type = state.type;

      if (state.visible) {
        disableScroll();
      } else {
        enableScroll();
      }
    });

    this.confirm.showRejectInput$.subscribe((visible) => {
      this.inputVisible = visible;
    });
  }

  ngOnDestroy(): void {
    this.dialogSub.unsubscribe();
    enableScroll();
  }

  onCancel(): void {
    this.confirm.cancel();
  }

  onConfirm(): void {
    this.confirm.confirm();
  }


  getButtonClass(): string {
    switch (this.type) {
      case 'confirm':
        return 'confirm-button-success';
      case 'delete':
        return 'confirm-button-error';
      default:
        return '';
    }
  }


}
